import "./ListGreenEurope.module.css";
import Header from "@/reusable_sections/Header";
import RemarkableCareers from "./sections/RemarkableCareers";
import Footer from "@/reusable_sections/Footer";
export default function ListGreenEuropePage() {
  return <div className='min-h-screen flex flex-col'>
      <Header />
      <RemarkableCareers />
      <Footer />
    </div>;
}